import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const useLeadsDashboard = () => {
    const [days, setDays] = useState(30);
    const [filter, setFilter] = useState("all");
    const [summary, setSummary] = useState(null);
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const [s, l] = await Promise.all([
                api.get("/events/summary", { params: { days } }),
                api.get("/leads", { params: filter === "all" ? {} : { status: filter } }),
            ]);
            setSummary(s.data);
            setLeads(l.data);
        } finally {
            setLoading(false);
        }
    }, [days, filter]);

    useEffect(() => {
        load().catch(() => {});
    }, [load]);

    const updateStatus = async (id, status) => {
        await api.patch(`/leads/${id}`, { status });
        load();
    };

    const remove = async (id) => {
        if (!window.confirm("Delete this enquiry permanently?")) return;
        await api.delete(`/leads/${id}`);
        load();
    };

    return { days, setDays, filter, setFilter, summary, leads, loading, load, updateStatus, remove };
};
